import React from 'react';
import { Text, VStack } from '@chakra-ui/react';
import { DivisionEnum, MessageType } from '../organisms/Message/MessageBody';
import {
  CourseSignages,
  CourseTrains,
  DispType,
  InboundEnum
} from '../organisms/Message/MessageListBox';

interface props {
  DispDatas: MessageType | undefined;
  Division: number;
  DispDataType: number;
  Title: string;
  ChooseList: Array<number>;
  Course: number;
  Condition: number;
  searchRefA?: React.MutableRefObject<HTMLSelectElement | null>;
  searchRefB?: React.MutableRefObject<HTMLSelectElement | null>;
}

export const ListBox: React.FC<props> = (props) => {
  const {
    DispDatas,
    Division,
    DispDataType,
    Title,
    ChooseList,
    Course,
    Condition,
    searchRefA,
    searchRefB
  } = props;

  return (
    <>
      <VStack>
        <Text>{Title}</Text>
        {Division === DivisionEnum.Train && DispDataType === DispType.Search && (
          <select
            ref={searchRefA}
            style={{ width: 320, border: '1px solid' }}
            size={6}
            multiple
          >
            {DispDatas?.trains.map((data, i) => {
              if (
                Course === data.course ||
                Course === CourseTrains.All ||
                Course === CourseTrains.None
              ) {
                if (Condition === data.train_group_id || Condition === 0) {
                  if (
                    ChooseList.find((elem) => elem === data.train_no) ===
                    undefined
                  ) {
                    return (
                      <option
                        key={'data_' + i}
                        value={data.train_no.toString()}
                      >
                        {data.course_name}
                      </option>
                    );
                  }
                }
              }
            })}
          </select>
        )}
        {Division === DivisionEnum.Train && DispDataType === DispType.Choose && (
          <select
            ref={searchRefB}
            style={{ width: 320, border: '1px solid' }}
            size={6}
            multiple
          >
            {DispDatas?.trains.map((data, i) => {
              if (
                ChooseList.find((elem) => elem === data.train_no) !== undefined
              ) {
                return (
                  <option key={'data_' + i} value={data.train_no}>
                    {data.course_name}
                  </option>
                );
              }
            })}
          </select>
        )}
        {Division === DivisionEnum.Tram && DispDataType === DispType.Search && (
          <select
            ref={searchRefA}
            style={{ width: 320, border: '1px solid' }}
            size={6}
            multiple
          >
            {DispDatas?.signages.map((data, i) => {
              if (
                data.courses.find((elem) => elem.course === Course) ||
                Course === CourseSignages.None
              ) {
                if (
                  Condition === data.inbound ||
                  Condition === InboundEnum.None
                ) {
                  if (
                    ChooseList.find((elem) => elem === data.signage_id) ===
                    undefined
                  ) {
                    return (
                      <option key={'data_' + i} value={data.signage_id}>
                        {data.name}
                      </option>
                    );
                  }
                }
              }
            })}
          </select>
        )}
        {Division === DivisionEnum.Tram && DispDataType === DispType.Choose && (
          <select
            ref={searchRefB}
            style={{ width: 320, border: '1px solid' }}
            size={6}
            multiple
          >
            {DispDatas?.signages.map((data, i) => {
              if (
                ChooseList.find((elem) => elem === data.signage_id) !==
                undefined
              ) {
                return (
                  <option key={'data_' + i} value={data.signage_id}>
                    {data.name}
                  </option>
                );
              }
            })}
          </select>
        )}
      </VStack>
    </>
  );
};
